var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compositiondropdown_box mt-0 d-flex align-items-center"},[_c('h6',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('spin-button',{attrs:{"max":_vm.max,"min":_vm.min},model:{value:(_vm.count),callback:function ($$v) {_vm.count=$$v},expression:"count"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }